import { render, staticRenderFns } from "./PnetMessageViewSideMenu.vue?vue&type=template&id=a604ede0"
import script from "./PnetMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports